import { FC, useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { IonIcon, IonPopover } from '@ionic/react'
import { alertCircleOutline } from 'ionicons/icons'

import { appConfig } from '@/services/config'
import { GetDepositDataResult } from '@/lib/hooks/wallet/useDeposit'
import { toTokenString } from '@/utils/token'

type WarningAlertProps = {
  minDepositAmount: GetDepositDataResult['minDepositAmount']
  isSuccess: boolean
}

export const WarningAlert: FC<WarningAlertProps> = ({
  minDepositAmount,
  isSuccess,
}) => {
  const { t } = useTranslation('common')
  const [isOpen, setIsOpen] = useState(false)
  const [wasPresented, setWasPresented] = useState(false)

  useEffect(() => {
    if (!isSuccess || wasPresented) return

    setIsOpen(true)
    setWasPresented(true)
  }, [isSuccess, wasPresented])

  const handleDismiss = () => setIsOpen(false)

  return (
    <IonPopover
      isOpen={isOpen}
      onDidDismiss={handleDismiss}
      className="deposit-warning-popover"
      showBackdrop
      backdropDismiss={false}
    >
      <div
        className="flex flex-col items-center px-3 py-4 text-center"
        data-test="popover"
      >
        <IonIcon
          icon={alertCircleOutline}
          color="danger"
          className="text-5xl mb-3"
        />
        <h3 className="mb-5">{t('deposit.warningTitle')}</h3>
        <span>
          <Trans>
            {t('deposit.warningDescription', {
              currency: appConfig.currency,
              minDepositAmount: minDepositAmount
                ? toTokenString(minDepositAmount)
                : 0,
            })}
          </Trans>
        </span>
      </div>
      <div className="flex border-t" data-test="popover-reply">
        <button className="w-full p-3" onClick={handleDismiss}>
          {t('deposit.warningUnderstood')}
        </button>
      </div>
    </IonPopover>
  )
}
